import { isJapan } from '../utils/validators/countries';
import type { RootState } from './store';

export const selectHasError = (state: RootState) => state.app.error !== null;

/** The backend refuses changes to a read-only cart; it can only be deleted. */
export const selectReadOnly = (state: RootState) => state.app.readOnly;

export const selectCurrencySymbol = (state: RootState) =>
  state.app.localization?.currencySymbol ?? '';

export const selectPayPalHidden = (state: RootState) => {
  const localizationCountry = state.app.localization?.countryCode ?? '';
  const billingCountry = state.billing.form.country;
  return isJapan(localizationCountry) || isJapan(billingCountry);
};
